import { render, staticRenderFns } from "./UiSearch.vue?vue&type=template&id=79c57a3d&lang=pug&"
import script from "./UiSearch.vue?vue&type=script&lang=js&"
export * from "./UiSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports